$(document).ready(function () {

  /* ---------------------------------------------------------------------
     Swiper initialization
  --------------------------------------------------------------------- */
  new Swiper('.collection-poduct-loop-slider', {
    slidesPerView: 4,
    spaceBetween: 30,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1024: { slidesPerView: 4 },
      768: { slidesPerView: 2 },
      320: { slidesPerView: 1.3, spaceBetween: 10 }
    }
  });

  /* ---------------------------------------------------------------------
     Helper functions
  --------------------------------------------------------------------- */

  // Select proper radio based on quantity
  function selectOptionBasedOnQuantity(qty, box) {
    let radio = null;
    if (qty >= 240) radio = box.find('input[value="240 CANS"]');
    else if (qty >= 10) radio = box.find('input[value="10 CANS"]');
    else if (qty >= 5) radio = box.find('input[value="5 CANS"]');
    else radio = box.find('input[value="1 CAN"]');

    if (radio && radio.length) {
      radio.prop('checked', true);
      box.find('.option-block-qty input[type="radio"]').not(radio).prop('checked', false);
    }
  }

  // 🧮 Update displayed price dynamically
  function updateCardPrice(box, qty) {
    const selectedRadio = box.find('.option-block-qty input[type="radio"]:checked');
    const priceEl = selectedRadio.closest('label').find('.option-price');

    if (!priceEl.length) return;

    // Extract prices & discount
    const basePrice = parseFloat(priceEl.attr('data-main-price')) || 0;
    const comparePrice = parseFloat(priceEl.attr('data-com-main-price')) || 0;
    const discount = parseFloat(selectedRadio.attr('data-discount')) || 0;

    // Convert Shopify cents → dollars if needed
    const mainPrice = (basePrice - discount) * qty;
    const comPrice = (comparePrice - discount) * qty;

    // Format prices
    const formattedMain =
      typeof Shopify !== "undefined" && Shopify.formatMoney
        ? Shopify.formatMoney(mainPrice)
        : `$${(mainPrice / 100).toFixed(2)}`;

    const formattedCompare =
      typeof Shopify !== "undefined" && Shopify.formatMoney
        ? Shopify.formatMoney(comPrice)
        : `$${(comPrice / 100).toFixed(2)}`;

    // Update visible price
    if (comparePrice > 0 && comparePrice > basePrice) {
      box.find('.product-card__price').html(`<del>${formattedCompare}</del> ${formattedMain}`);
    } else {
      box.find('.product-card__price').html(formattedMain);
    }
  }

  // Update radios in product options by ID
  function updateRadioFromQty(id, qty) {
    let match = '1 CAN';
    if (qty >= 240) match = '240 CANS';
    else if (qty >= 10) match = '10 CANS';
    else if (qty >= 5) match = '5 CANS';

    $(`.product-options-bottom[data-product-id="${id}"] input[type="radio"]`).each(function () {
      $(this).prop("checked", $(this).val().trim().toUpperCase() === match);
    });
  }

  // Sync input + hidden qty + radios by ID
  function updateQuantityInputs(id, qty) {
    $(`.card-qty-value[data-product-id="${id}"]`).val(qty);
    $(`.card-qty-hidden[data-product-id="${id}"]`).val(qty);
    updateRadioFromQty(id, qty);
  }

  /* ---------------------------------------------------------------------
     Quantity +/− and input listeners
  --------------------------------------------------------------------- */

$(document).on("click", ".card-qty-plus", function () {
    const box = $(this).closest('.product-card-box');
    const parent = $(this).closest(".card-qty-selector");
    const id = parent.data("product-id");
    const input = parent.find(".card-qty-value");
    let qty = parseInt(input.val()) || 1;
    qty++;
    updateQuantityInputs(id, qty);
    updateCardPrice(box, qty);
  });

  $(document).on("click", ".card-qty-minus", function () {
    const box = $(this).closest('.product-card-box');
    const parent = $(this).closest(".card-qty-selector");
    const id = parent.data("product-id");
    const input = parent.find(".card-qty-value");
    let qty = parseInt(input.val()) || 1;
    qty = Math.max(1, qty - 1);
    updateQuantityInputs(id, qty);
    updateCardPrice(box, qty);
  });

   $(document).on("input", ".card-qty-value", function () {
    const box = $(this).closest('.product-card-box');
    const id = $(this).data("product-id");
    const qty = parseInt($(this).val()) || 1;
    updateQuantityInputs(id, qty);
    updateCardPrice(box, qty);
  });

  /* ---------------------------------------------------------------------
     Radio option change → price & qty update
  --------------------------------------------------------------------- */

 $(document).on("change", ".option-block-qty input[type='radio']", function () {
    if ($(this).is(":checked")) {
      const box = $(this).closest('.product-card-box');
      const id = box.find(".card-qty-value").data("product-id");

      // Extract numeric qty from value text like "10 CANS"
      const matchQty = parseInt($(this).val()) || 1;

      updateQuantityInputs(id, matchQty);
      updateCardPrice(box, matchQty);
    }
  });

  /* ---------------------------------------------------------------------
     Add to Cart AJAX
  --------------------------------------------------------------------- */

$(document).on("click", ".card-add-to-cart-submit", function (e) {
  console.log('demo');
  e.preventDefault();
  const $btn = $(this);
  const $box = $btn.closest(".product-card-box"); // 👈 new
  const $form = $btn.closest("form");
  const id = $btn.data("variant-id");
  const qty = parseInt($box.find(".card-qty-hidden").val()) || 1; 
  console.log(qty);
    const $spinner = $btn.find('.loading__spinner');

    $btn.addClass('loading').prop("disabled", true);
    $spinner.removeClass('hidden');

    if (!id) {
      console.error("Variant ID missing.");
      $spinner.addClass('hidden');
      $btn.removeClass('loading').prop("disabled", false);
      return;
    }

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: { id, quantity: qty },
      dataType: "json",
      success: function () {
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: JSON.stringify({ updates: {}, sections: ["cart-drawer", "cart-icon-bubble"] }),
          contentType: "application/json",
          dataType: "json",
          success: function (cart) {
            $spinner.addClass('hidden');
            $btn.removeClass('loading').prop("disabled", false);

            const $drawer = $("cart-drawer");
            if ($drawer.length && typeof $drawer[0].renderContents === "function") {
              $drawer[0].renderContents(cart);
              $drawer.removeClass("is-empty").addClass("active");
            }

            if (typeof sections !== "undefined" && sections["cart-icon-bubble"]) {
              $(".cart-icon-bubble").html(sections["cart-icon-bubble"]);
            }
          },
          error: function (xhr) {
            console.error("Error updating cart:", xhr.responseText);
          }
        });
      },
      error: function (xhr) {
        console.error("Error adding to cart:", xhr.responseText);
    
        $spinner.addClass('hidden');
        $btn.removeClass('loading').prop("disabled", false);
      }
    });
  });
});
